export const translations = {
  bg: {
    nav: {
      about: "За нас",
      practice: "Практики",
      team: "Екип",
      contact: "Контакти",
      cta: "Свържете се",
    },
    hero: {
      overline: "Адвокатска кантора · София · от 2008",
      title_a: "Право,",
      title_b: "изградено върху",
      title_c: "принципи.",
      quote: "„Ако нямаше лоши хора, нямаше да има и добри адвокати.\" — Чарлз Дикенс",
      lead:
        "Серкеджиев Law Office е независима адвокатска кантора, която консултира български и чуждестранни клиенти по корпоративни, банкови, имотни, конкурентни, трудови и търговски въпроси.",
      cta_primary: "Заявете консултация",
      cta_secondary: "Нашите практики",
    },
    about: {
      overline: "За кантората",
      kicker: "Основана 2008",
      title: "Индивидуален подход. Международен стандарт.",
      p1:
        "През 2008 г. адвокат с дългогодишен опит в гражданското право и съдебните производства основава кантората с амбицията да изгради организация, моделирана по образец на утвърдените международни кантори.",
      p2:
        "От тогава кантората предлага индивидуален подход във всеки казус, отчитайки особеностите на бизнеса на клиента и неговите предпочитания. Работим с национални и чуждестранни компании, които развиват дейност в България.",
      stats: [
        { value: "15+", label: "Години практика" },
        { value: "6", label: "Основни направления" },
        { value: "3", label: "Работни езика" },
      ],
    },
    practice: {
      overline: "Практики",
      title: "Какво правим",
      lead:
        "Шест ключови области, в които предоставяме консултации, изготвяме документация и представителство.",
      items: [
        {
          n: "01",
          title: "Търговско право и договори",
          desc:
            "Структуриране на сделки, изготвяне и преговори по търговски договори, дистрибуторски и франчайз отношения.",
        },
        {
          n: "02",
          title: "Корпоративно право",
          desc:
            "Учредяване и преобразуване на дружества, корпоративно управление, сливания и придобивания.",
        },
        {
          n: "03",
          title: "Трудово право",
          desc:
            "Трудови договори, политика по човешки ресурси, прекратяване, спорове пред Кодекса на труда.",
        },
        {
          n: "04",
          title: "Съдебни производства",
          desc:
            "Процесуално представителство по граждански, търговски и административни дела пред всички инстанции.",
        },
        {
          n: "05",
          title: "Недвижими имоти и строителство",
          desc:
            "Покупко-продажби, due diligence на имоти, инвестиционни проекти, строителни договори.",
        },
        {
          n: "06",
          title: "Данъчно право",
          desc:
            "Данъчно планиране, ревизии, обжалване на актове, ДДС и корпоративно облагане.",
        },
      ],
    },
    team: {
      overline: "Екип",
      title: "Управляващ съдружник",
      lead:
        "Адвокат с дългогодишен опит, ангажиран към качеството и независимостта.",
      partner1: {
        name: "Антон Серкеджиев",
        role: "Управляващ съдружник",
        bio:
          "Завършил Софийски университет „Св. Климент Охридски\", Юридически факултет, 1998 г. Член на Софийска адвокатска колегия от 2003 г.",
        experience: "Опит: НВМС 2000–2003 · Consultlex 2003–2006 · Penev & Partners 2006–2008",
        languages: "Италиански · Английски · Руски",
        practice: "Търговско, гражданско, корпоративно, имотно, административно, трудово право, ГПК, чуждестранни инвестиции, M&A, данъчно право.",
        email: "aserkedjiev@lawsn.com",
        phone: "+359 88 755 3482",
      },
    },
    contact: {
      overline: "Контакти",
      title: "Пишете ни.",
      lead:
        "Опишете накратко казуса и ще се свържем с вас в работно време.",
      address_label: "Адрес",
      address: "ул. „Коста Лулчев\" 10, вх. 1, ет. 1\n1113 София, България",
      phone_label: "Телефон",
      fax_label: "Факс",
      email_label: "Имейл",
      form: {
        name: "Име и фамилия",
        email: "Имейл",
        phone: "Телефон (по избор)",
        subject: "Тема",
        message: "Съобщение",
        submit: "Изпрати съобщението",
        sending: "Изпращане…",
        success: "Благодарим. Получихме съобщението ви.",
        error: "Възникна грешка. Опитайте отново.",
        consent: "С изпращането се съгласявате с обработката на данните за връзка.",
      },
    },
    footer: {
      tagline: "Serkedjiev Law Office · Адвокатска кантора",
      rights: "Всички права запазени.",
      built: "София · България",
    },
  },
  en: {
    nav: {
      about: "About",
      practice: "Practice",
      team: "Team",
      contact: "Contact",
      cta: "Get in touch",
    },
    hero: {
      overline: "Law Office · Sofia · Since 2008",
      title_a: "Law,",
      title_b: "built on",
      title_c: "principle.",
      quote: '"If there were no bad people, there would be no good lawyers." — Charles Dickens',
      lead:
        "Serkedjiev Law Office is an independent Bulgarian law office advising national and foreign clients on corporate, banking, real estate, competition, employment and commercial matters.",
      cta_primary: "Request a consultation",
      cta_secondary: "Our practice areas",
    },
    about: {
      overline: "About the firm",
      kicker: "Established 2008",
      title: "Individual approach. International standard.",
      p1:
        "In 2008, an attorney with extensive experience in civil law and litigation founded Serkedjiev Law Office, driven by the aim to create an organization modeled on reputed international law firms.",
      p2:
        "Since then we have delivered an individual approach in each case, considering the particularities of each client's business and preferences. We advise both national and foreign companies developing their activities in Bulgaria.",
      stats: [
        { value: "15+", label: "Years of practice" },
        { value: "6", label: "Core practice areas" },
        { value: "3", label: "Working languages" },
      ],
    },
    practice: {
      overline: "Practice",
      title: "What we do",
      lead:
        "Six core areas in which we advise, draft, negotiate and litigate on behalf of our clients.",
      items: [
        {
          n: "01",
          title: "Commercial Law & Contracts",
          desc:
            "Transaction structuring, drafting and negotiating commercial contracts, distribution and franchise relationships.",
        },
        {
          n: "02",
          title: "Corporate Law",
          desc:
            "Incorporation and reorganization of companies, corporate governance, mergers and acquisitions.",
        },
        {
          n: "03",
          title: "Labour Law",
          desc:
            "Employment agreements, HR policies, terminations and disputes under the Bulgarian Labour Code.",
        },
        {
          n: "04",
          title: "Litigation",
          desc:
            "Court representation in civil, commercial and administrative cases before all instances.",
        },
        {
          n: "05",
          title: "Real Estate & Construction",
          desc:
            "Acquisitions, real-estate due diligence, investment projects, construction agreements.",
        },
        {
          n: "06",
          title: "Tax Law",
          desc:
            "Tax planning, audits, challenges to tax acts, VAT and corporate income tax matters.",
        },
      ],
    },
    team: {
      overline: "Team",
      title: "Managing Partner",
      lead:
        "An experienced attorney committed to quality and independence.",
      partner1: {
        name: "Anton Serkedjiev",
        role: "Managing Partner",
        bio:
          'Sofia University "St. Kliment Ohridski", Faculty of Law, 1998. Member of the Sofia Bar Association since 2003.',
        experience: "Experience: National Veterinary Service 2000–2003 · Consultlex 2003–2006 · Penev & Partners 2006–2008",
        languages: "Italian · English · Russian",
        practice: "Commercial, Civil, Contract, Corporate, Property, Administrative, Labour, Civil Procedure, Foreign Investments, M&A, Tax.",
        email: "aserkedjiev@lawsn.com",
        phone: "+359 88 755 3482",
      },
    },
    contact: {
      overline: "Contact",
      title: "Write to us.",
      lead: "Briefly describe your matter and we will respond during office hours.",
      address_label: "Address",
      address: "10 Kosta Lulchev str., entr. 1, fl. 1\n1113 Sofia, Bulgaria",
      phone_label: "Phone",
      fax_label: "Fax",
      email_label: "Email",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        subject: "Subject",
        message: "Message",
        submit: "Send message",
        sending: "Sending…",
        success: "Thank you. We have received your message.",
        error: "Something went wrong. Please try again.",
        consent: "By submitting you consent to the processing of your contact data.",
      },
    },
    footer: {
      tagline: "Serkedjiev Law Office",
      rights: "All rights reserved.",
      built: "Sofia · Bulgaria",
    },
  },
  it: {
    nav: {
      about: "Studio",
      practice: "Aree",
      team: "Avvocati",
      contact: "Contatti",
      cta: "Contattaci",
    },
    hero: {
      overline: "Studio Legale · Sofia · dal 2008",
      title_a: "Diritto,",
      title_b: "fondato sui",
      title_c: "principi.",
      quote: '"Se non ci fossero persone cattive, non ci sarebbero buoni avvocati." — Charles Dickens',
      lead:
        "Serkedjiev Law Office è uno studio legale indipendente che assiste clienti nazionali ed esteri in materia societaria, bancaria, immobiliare, di concorrenza, lavoro e commerciale.",
      cta_primary: "Richiedi una consulenza",
      cta_secondary: "Le nostre aree",
    },
    about: {
      overline: "Lo Studio",
      kicker: "Fondato nel 2008",
      title: "Approccio individuale. Standard internazionale.",
      p1:
        "Nel 2008, un avvocato con vasta esperienza nel diritto civile e nel contenzioso ha fondato lo Studio Serkedjiev, con l'obiettivo di creare un'organizzazione sul modello dei più affermati studi legali internazionali.",
      p2:
        "Da allora forniamo un approccio personalizzato per ogni pratica, tenendo conto delle peculiarità dell'attività di ciascun cliente. Assistiamo società bulgare ed estere che operano in Bulgaria.",
      stats: [
        { value: "15+", label: "Anni di attività" },
        { value: "6", label: "Aree principali" },
        { value: "3", label: "Lingue di lavoro" },
      ],
    },
    practice: {
      overline: "Aree",
      title: "Cosa facciamo",
      lead:
        "Sei aree principali in cui consulenza, contrattualistica, negoziazione e contenzioso.",
      items: [
        {
          n: "01",
          title: "Diritto Commerciale & Contratti",
          desc:
            "Strutturazione di operazioni, redazione di contratti commerciali, distribuzione e franchising.",
        },
        {
          n: "02",
          title: "Diritto Societario",
          desc:
            "Costituzione e riorganizzazione di società, governance societaria, fusioni e acquisizioni.",
        },
        {
          n: "03",
          title: "Diritto del Lavoro",
          desc:
            "Contratti di lavoro, politiche HR, licenziamenti e controversie ai sensi del Codice del Lavoro bulgaro.",
        },
        {
          n: "04",
          title: "Contenzioso",
          desc:
            "Rappresentanza in cause civili, commerciali e amministrative dinanzi a tutti i gradi di giudizio.",
        },
        {
          n: "05",
          title: "Immobiliare & Edilizia",
          desc:
            "Compravendite, due diligence immobiliare, progetti di investimento, contratti di costruzione.",
        },
        {
          n: "06",
          title: "Diritto Tributario",
          desc:
            "Pianificazione fiscale, verifiche, ricorsi avverso atti tributari, IVA e imposta sul reddito societario.",
        },
      ],
    },
    team: {
      overline: "Team",
      title: "Socio Amministratore",
      lead:
        "Un avvocato esperto, impegnato per qualità e indipendenza.",
      partner1: {
        name: "Anton Serkedjiev",
        role: "Socio Amministratore",
        bio:
          'Università di Sofia "St. Kliment Ohridski", Facoltà di Giurisprudenza, 1998. Iscritto all\'Ordine degli Avvocati di Sofia dal 2003.',
        experience: "Esperienza: Servizio Veterinario 2000–2003 · Consultlex 2003–2006 · Penev & Partners 2006–2008",
        languages: "Italiano · Inglese · Russo",
        practice: "Commerciale, civile, contrattuale, societario, immobiliare, amministrativo, lavoro, procedura civile, investimenti esteri, M&A, tributario.",
        email: "aserkedjiev@lawsn.com",
        phone: "+359 88 755 3482",
      },
    },
    contact: {
      overline: "Contatti",
      title: "Scriveteci.",
      lead: "Descrivete brevemente la pratica e vi risponderemo negli orari d'ufficio.",
      address_label: "Indirizzo",
      address: "10 Kosta Lulchev str., scala 1, p. 1\n1113 Sofia, Bulgaria",
      phone_label: "Telefono",
      fax_label: "Fax",
      email_label: "Email",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono (opzionale)",
        subject: "Oggetto",
        message: "Messaggio",
        submit: "Invia messaggio",
        sending: "Invio in corso…",
        success: "Grazie. Abbiamo ricevuto il vostro messaggio.",
        error: "Si è verificato un errore. Riprovate.",
        consent: "Inviando acconsentite al trattamento dei dati di contatto.",
      },
    },
    footer: {
      tagline: "Serkedjiev Law Office · Studio Legale",
      rights: "Tutti i diritti riservati.",
      built: "Sofia · Bulgaria",
    },
  },
};

export const LANGUAGES = [
  { code: "bg", label: "BG" },
  { code: "en", label: "EN" },
  { code: "it", label: "IT" },
];

